import axios from 'axios'
import { api } from "@config"
import { clearAllCookies, getCookieByName, setCookieByName } from '../utils'
import { showSnackBar } from "../utils"

import { getConfig } from "../utils/config"

const config = getConfig()

const apiURL = config.api.baseUrl

console.debug("API_URL", apiURL)

// Load the enviroments config vars

const API_URL = apiURL
const API_VERSION = process.env.REACT_APP_API_VERSION
const API_ROOT = process.env.REACT_APP_API_ROOT

const baseUrl = `${API_URL}/${API_ROOT}/${API_VERSION}/`
export const baseURL = baseUrl

const instance = axios.create({
    baseURL,
    timeout: 120000,
})
// urls to save on session storage
const URLS_FOR_SAVE_ON_CACHE = ["payment-methods/"]

// the basic requests system
// Flag para evitar múltiplas renovações simultâneas
let _isRefreshing = false
let _refreshSubscribers = []

function _subscribeToTokenRefresh(cb) {
    _refreshSubscribers.push(cb)
}

function _onRefreshed(newToken) {
    _refreshSubscribers.forEach(cb => cb(newToken))
    _refreshSubscribers = []
}

async function refreshToken() {
    if (_isRefreshing) {
        // Já está renovando: aguarda o resultado
        return new Promise((resolve, reject) => {
            _subscribeToTokenRefresh(token => resolve(token))
        })
    }

    _isRefreshing = true
    const refresh = getCookieByName("refresh")
    const url = `${API_URL}/api/token/refresh/`

    try {
        const response = await axios.post(url, { refresh })
        const newAccess = response.data.access
        setCookieByName("access", newAccess)
        _onRefreshed(newAccess)
        return newAccess
    } catch (error) {
        _refreshSubscribers = []
        // Limpa sessão e redireciona para login
        var cookies = document.cookie.split(';');
        for (var i = 0; i < cookies.length; i++) {
            document.cookie = `${cookies[i]}=;expires=${new Date(0).toUTCString()}`
        }
        window.localStorage.clear()
        document.cookie = ""
        window.location.href = ""
        throw error
    } finally {
        _isRefreshing = false
    }
}

instance.interceptors.request.use(config => {
    const access = getCookieByName("access")
    const headers = {
        "Content-Type": "application/json",
        "Authorization": `Bearer ${access}`
    }
    config["headers"] = headers
    return config
}, error => Promise.reject(error))

instance.interceptors.response.use(response => {
    if (URLS_FOR_SAVE_ON_CACHE.includes(response.config.url)) {
        try {
            sessionStorage.setItem(response.config.url, JSON.stringify(response.data))
        } catch (error) { }
    }
    return response.data
}, async error => {
    const originalRequest = error.config

    if (error.response) {
        const { status, statusText } = error.response
        const is401 = status === 401 || (statusText && statusText === "Unauthorized")

        // Evita loop infinito: não tenta renovar na própria rota de refresh
        if (is401 && !originalRequest._retry) {
            originalRequest._retry = true
            try {
                const newToken = await refreshToken()
                // Atualiza o header e reenvia a requisição original automaticamente
                originalRequest.headers["Authorization"] = `Bearer ${newToken}`
                return instance(originalRequest)
            } catch (refreshError) {
                return Promise.reject(refreshError)
            }
        }
    }

    return Promise.reject(error)
})

function requestError(error, reject) {
    if (error.message) {
        if (error.message === "Network Error") {
            showSnackBar("Falha na comunicação com a rede.")
            reject(error)
            return
        }
    }
    if (error.response) {
        if (error.response.status === 400) {
            reject(error.response.data)
            return
        } else if (error.response.status === 500) {
            reject(error.response.data)
            return
        }
        reject(error.response)
    } else {
        reject(error)
    }
}

export function request(data, isBranchUser = true, branchOwnerId = null) {
    if (isBranchUser) {
        if (!data.params) {
            data["params"] = {}
        }
        data["params"]["branch_owner"] = branchOwnerId || getCookieByName("branch_owner_id")
    }

    return new Promise(async (resolve, reject) => {
        if (data.url) {
            if (URLS_FOR_SAVE_ON_CACHE.includes(data.url)) {
                if (sessionStorage.getItem(data.url)) {
                    try {
                        resolve(JSON.parse(sessionStorage.getItem(data.url)))
                        return
                    } catch (error) { }
                }
            }
        }
        instance(data)
            .then(response => {
                resolve(response)
            })
            .catch(error => {
                requestError(error, reject)
            })
    })
}

export class Request {
    constructor(baseUrl) {
        this.url = baseUrl
    }

    _getCookie(name) {
        const cookies = document.cookie.split(';')
        const cookie = cookies.find(cookie => cookie.includes(name))
        if (cookie) {
            return cookie.split('=')[1]
        } else {
            if (name == "access") {
                window.localStorage.clear()
                window.location.href = "/"
            }
        }
    }

    _updateCookie(cookieName, newValue) {
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        const expires = `expires = ${date.toUTCString()}`
        let newCookies = ""
        const cookies = document.cookie.split(';')
        for (let i = 0; i < cookies.length; i++) {
            const cookie = cookies[i]
            const [name, value] = cookie.split('=')

            if (` ${cookieName} ` === name) {
                newCookies += `${name}=${newValue}; `
            } else {
                newCookies += `${name}=${value}; `
            }
        }
        document.cookie = newCookies + expires

    }

    _setCookie(name, value) {
        const date = new Date();
        date.setTime(date.getTime() + (24 * 60 * 60 * 1000));
        const expires = `expires = ${date.toUTCString()} `
        document.cookie = `${name}=${value};${document.cookie}; path = /;${expires}`
    }


    _getAuthorizationToken() {
        const access = this._getCookie('access')
        return `Bearer ${access}`
    }


    _getBranchOwnerId() {
        return this._getCookie('branch_owner_id')
    }

    _request(axiosrequestData) {
        axiosrequestData["headers"] = {
            "Content-Type": "application/json",
        }
        if (axiosrequestData.useAuthHeaders) {
            axiosrequestData["headers"]["Authorization"] = this._getAuthorizationToken()
        }
        if (axiosrequestData.useBranchOwner) {
            if (!axiosrequestData["params"]) {
                axiosrequestData["params"] = {}
            }
            axiosrequestData["params"]["branch_owner"] = this._getBranchOwnerId()
        }

        return new Promise((resolve, reject) => {
            axios.request(axiosrequestData)
                .then(response => {
                    resolve(response.data)
                })
                .catch(err => {
                    if (err.response) {
                        const statusCode = err.response.status
                        switch (statusCode) {
                            case 400:
                                reject(err.response.data)
                                break
                            case 401:
                                const statusText = err.response.statusText
                                const data = err.response.data
                                const code = data.code
                                const reloadToken = statusText === "Unauthorized" && code === 'token_not_valid'
                                const userInactive = false
                                if (reloadToken) {
                                    const refresh = this._getCookie("refresh")
                                    axios.post(`${this.url}/api/token/refresh/`, {
                                        refresh: refresh
                                    })
                                        .then(response => {
                                            this._setCookie("access", response.data.access)
                                            this._request(axiosrequestData)
                                                .then(data => resolve(data))
                                        })
                                        .catch(err => { })
                                }
                                break
                            case 403:
                                reject(err.response)
                                break
                            case 500:
                                reject(err.response.data)
                                break

                        }
                    }
                })
        })
    }

    __request(requestData, useAuthHeaders = true, useBranchOwner = true) {
        requestData["headers"] = {
            "Content-Type": "application/json",
        }
        if (useAuthHeaders) {
            requestData["headers"]["Authorization"] = this._getAuthorizationToken()
        }
        if (useBranchOwner) {
            if (!requestData["params"]) {
                requestData["params"] = {}
            }
            requestData["params"]["branch_owner"] = this._getBranchOwnerId()
        }

        return new Promise((resolve, reject) => {
            instance(requestData)
                .then(response => {
                    resolve(response.data)
                })
                .catch(error => {
                    if (error.response) {
                        const { status } = error.response
                        if (status === 400) {
                            reject(error.response.data)
                        } else if (status === 401) {
                            const refresh = this._getCookie("refresh")
                            axios.post(`${API_URL}/api/token/refresh/`, {
                                refresh: refresh
                            })
                                .then(reloadResponse => {
                                    const { access } = reloadResponse.data
                                    this._setCookie("access", access)
                                    this.__request(requestData)
                                })
                        } else if (status === 500) {
                            reject(error.response.data)
                        }
                    }
                })
        })
    }


    get(path, params, useAuthHeaders = true, useBranchOwner = true) {
        const request = {
            url: `${this.url}${path}`,
            method: "GET",
            params: params
        }
        request["useAuthHeaders"] = useAuthHeaders
        request["useBranchOwner"] = useBranchOwner
        return this._request(request)
    }


    post(path, data, params = {}, useAuthHeaders = true, useBranchOwner = true) {
        const request = {
            url: `${this.url}${path}`,
            method: "POST",
            data: data,
            params: params
        }
        request["useAuthHeaders"] = useAuthHeaders
        request["useBranchOwner"] = useBranchOwner
        return this._request(request)
    }


    put(path, data, params = {}, useAuthHeaders = true, useBranchOwner = true) {
        const request = {
            url: `${this.url}${path}`,
            method: "PUT",
            data: data,
            params: params
        }
        request["useAuthHeaders"] = useAuthHeaders
        request["useBranchOwner"] = useBranchOwner
        return this._request(request)
    }

    delete() {
        return axios.delete(this.url)
    }

    showError(message) {
        const divError = document.createElement('div')
        divError.classList.add('.alert-lkhasdk')
        divError.classList.add('error')

        const p = document.createElement('p')
        p.classList.add('body')
        p.innerText = message
        divError.appendChild(p)
    }

}

class API extends Request {
    constructor() {
        super('');
    }

    auth(email, password) {
        const data = { email, password };
        return super.post('/api/token/', data, {}, false, false)
            .then(response => {
                setCookieByName('access', response.access);
                setCookieByName('refresh', response.refresh);

                window.localStorage.setItem(
                    "easygestorweb_apikey",
                    JSON.stringify(response.access)
                );
                window.localStorage.setItem(
                    "easygestorweb_refresh_token",
                    JSON.stringify(response.refresh)
                );

                return response;
            })
            .catch(err => {
                showSnackBar("Credenciais inválidas ou erro na rede.");
                throw err;
            });
    }

    register(data) {
        return super.post('/api/v1/users/', data);
    }

    searchUser(email) {
        return super.post('/api/v1/users/search/', { email });
    }

    getUser(id) {
        return super.get(`/api/v1/users/${id}/`, {}, true, true).then(data => {
            window.localStorage.setItem(
                "easygestorweb_userdata",
                JSON.stringify(data)
            );
            return data;
        });
    }

    getActiveBranch() {
        return super.get('/api/v1/branches/').then(data => {
            if (data && data[0]) {
                setCookieByName('branch_owner_id', data[0].id);
                window.localStorage.setItem(
                    "easygestorweb_current_branch",
                    JSON.stringify(data[0])
                );
            }
            window.localStorage.setItem(
                "easygestorweb_all_branches",
                JSON.stringify(data)
            );
            return data;
        });
    }

    getBranch(id) {
        return super.get(`/api/v1/branches/${id}/`);
    }

    createBranch(data) {
        return super.post('/api/v1/branches/', data);
    }

    editBranch(id, data) {
        return super.put(`/api/v1/branches/${id}/`, data);
    }

    getPlans() {
        return super.get('/api/v1/plans/');
    }

    getBranchPlan() {
        return super.get('/api/v1/branch-plans/');
    }

    upgradePlan(new_plan_id) {
        return super.put('/api/v1/branch-plans/upgrade/', { new_plan_id });
    }

    createBranchPlan(plan) {
        return super.post('/api/v1/branch-plans/', { plan });
    }

    getBranchInvoices(params = {}) {
        return super.get('/api/v1/invoices/', params);
    }

    getNotifications() {
        return super.get('/api/v1/branch-notifications/').then(data => data ? data.notifications : []);
    }

    makeSeenNotifications() {
        return super.post('/api/v1/branch-notifications/');
    }

    getCategories() {
        return super.get('/api/v1/products/categories/');
    }

    createProduct(data) {
        return super.post('/api/v1/products/', data);
    }

    getProduct(id) {
        return super.get(`/api/v1/products/${id}/`);
    }

    getProducts(params = {}) {
        return super.get('/api/v1/products/', params);
    }

    getUnits() {
        return super.get('/api/v1/products/units/');
    }

    searchCFOP(params = {}) {
        return super.get('/api/v1/products/cfop/', params);
    }

    searchCEST(params = {}) {
        return super.get('/api/v1/products/cest/', params);
    }

    createClient(data, params = {}) {
        return super.post('/api/v1/clients/', data, params);
    }

    getClient(id) {
        return super.get(`/api/v1/clients/${id}/`);
    }

    getClients(params = {}) {
        return request({ url: "clients/", params });
    }

    getTransporters() {
        return super.get('/api/v1/nfe-transporter/');
    }

    getPaymentMehtods() {
        return super.get('/api/v1/payment-methods/');
    }

    getNFeConfig() {
        return super.get('/api/v1/config/');
    }

    updateConfig(data) {
        return super.put(`/api/v1/config/${data.id}/`, data);
    }

    listNFe(params = {}) {
        return super.get('/api/v1/nfe/', params);
    }

    donwloadBase64File(base64, filename, mime) {
        // Implementação original omitida ou transferida para utils
    }

    getNFeBase64(params = {}) {
        return super.get('/api/v1/nfe/download/', params);
    }

    getNFeBy(id) {
        return super.get(`/api/v1/nfe/${id}/`);
    }

    verifyNFeStatus(id) {
        return super.post(`/api/v1/nfe/${id}/has-pending/`, { id });
    }

    createNFe(nfe) {
        return super.post('/api/v1/nfe/', nfe);
    }

    NFeHistory(params = {}) {
        return super.get(`/api/v1/nfe/`, params);
    }

    downloadNFe(id, params = { file: "pdf" }) {
        return super.post(`/api/v1/nfe/${id}/download/`, {}, params);
    }
}

const client = new API();

export default client;


// WEBPACK FOOTER //
// ./src/api/index.js